// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js??ref--6-oneOf-0-1!../../../../../postcss-loader/dist/cjs.js!../../../../../../src/overrides/venia-ui/components/LoadingIndicator/indicator.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accountChip-root-FDh {\n}\n\n.accountChip-loader-3z0 {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "accountChip-root-FDh gap-x-2xs grid grid-cols-autoFirst grid-flow-col items-center",
	"loader": "accountChip-loader-3z0 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["indicator"] + ""
};
export default ___CSS_LOADER_EXPORT___;
